import React, { useState } from "react";
import { downloadSitemap, generateSitemap } from "../../utils/sitemapGenerator";
import { clearSitemapCache } from "./SitemapXMLRoute";

const SitemapGenerator = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [sitemapContent, setSitemapContent] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  const handleGenerateSitemap = async () => {
    setIsGenerating(true);
    try {
      const sitemap = await generateSitemap();
      setSitemapContent(sitemap);
      setShowPreview(true);
    } catch (error) {
      console.error("Error generating sitemap:", error);
      alert("Error generating sitemap. Please check the console for details.");
    } finally {
      setIsGenerating(false);
    }
  };

  const handleDownloadSitemap = async () => {
    setIsGenerating(true);
    try {
      const success = await downloadSitemap();
      if (success) {
        alert("Sitemap downloaded successfully!");
      } else {
        alert("Error downloading sitemap. Please try again.");
      }
    } catch (error) {
      console.error("Error downloading sitemap:", error);
      alert("Error downloading sitemap. Please check the console for details.");
    } finally {
      setIsGenerating(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(sitemapContent)
      .then(() => {
        alert("Sitemap copied to clipboard!");
      })
      .catch((err) => {
        console.error("Error copying to clipboard:", err);
        alert("Error copying to clipboard");
      });
  };

  const handleClearCache = () => {
    clearSitemapCache();
    alert(
      "Sitemap cache cleared! The sitemap will regenerate automatically on the next visit to /sitemap.xml"
    );
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <h1>Sitemap Generator</h1>
      <p>
        Generate a dynamic sitemap.xml for your website including all static and
        dynamic pages.
      </p>
      <br />
      {/* <div
        style={{
          marginBottom: "20px",
          padding: "15px",
          backgroundColor: "#e7f3ff",
          borderRadius: "4px",
          border: "1px solid #b3d9ff",
        }}
      >
        <h3 style={{ margin: "0 0 10px 0", color: "#0066cc" }}>
          🔄 Automatic Regeneration
        </h3>
        <p style={{ margin: "5px 0", fontSize: "14px" }}>
          <strong>Good News!</strong> Your sitemap at <code>/sitemap.xml</code>{" "}
          now regenerates automatically:
        </p>
        <ul style={{ margin: "10px 0", paddingLeft: "20px", fontSize: "14px" }}>
          <li>✅ Regenerates every hour with latest content from your API</li>
          <li>
            ✅ Automatically includes/excludes pages based on their ACTIVE/HOLD
            status
          </li>
          <li>✅ No manual upload needed - it updates automatically!</li>
        </ul>
        <p style={{ margin: "10px 0 0 0", fontSize: "14px" }}>
          <strong>After changing page status in admin:</strong> Wait up to 1
          hour, or click "Clear Cache" below to force immediate regeneration.
        </p>
      </div> */}

      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={handleGenerateSitemap}
          disabled={isGenerating}
          style={{
            padding: "10px 20px",
            marginRight: "10px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: isGenerating ? "not-allowed" : "pointer",
          }}
        >
          {isGenerating ? "Generating..." : "Generate Sitemap"}
        </button>

        <button
          onClick={handleDownloadSitemap}
          disabled={isGenerating}
          style={{
            padding: "10px 20px",
            marginRight: "10px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: isGenerating ? "not-allowed" : "pointer",
          }}
        >
          {isGenerating ? "Generating..." : "Download Sitemap"}
        </button>

        {/* <button
          onClick={handleClearCache}
          style={{
            padding: "10px 20px",
            backgroundColor: "#ffc107",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          🔄 Clear Cache & Force Regeneration
        </button> */}
      </div>

      {showPreview && sitemapContent && (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <h3>Sitemap Preview:</h3>
            <button
              onClick={copyToClipboard}
              style={{
                padding: "5px 10px",
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Copy to Clipboard
            </button>
          </div>

          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              maxHeight: "500px",
              overflow: "auto",
            }}
          >
            <pre
              style={{
                margin: 0,
                padding: "15px",
                backgroundColor: "#f8f9fa",
                fontSize: "12px",
                lineHeight: "1.4",
              }}
            >
              {sitemapContent}
            </pre>
          </div>

          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              backgroundColor: "#e9ecef",
              borderRadius: "4px",
            }}
          >
            <h4>Instructions for FileZilla Upload:</h4>
            <ol>
              <li>
                Click "Download Sitemap" to save the sitemap.xml file to your
                computer
              </li>
              <li>Open FileZilla and connect to your web server</li>
              <li>
                Navigate to your website's root directory (usually public_html
                or www)
              </li>
              <li>Upload the sitemap.xml file to the root directory</li>
              <li>
                Your sitemap will be accessible at:
                https://yourdomain.com/sitemap.xml
              </li>
              <li>
                Submit the sitemap URL to Google Search Console and other search
                engines
              </li>
            </ol>
          </div>
        </div>
      )}
    </div>
  );
};

export default SitemapGenerator;
